import React from 'react';
import { useDragLayer } from 'react-dnd';

// Local Constants
import { EVENT_TIMELINE_CELL, EVENT_TABLE_ROW } from '../../constants';

// Components
import StyledEventsTimelineEvent from '../StyledEventsTimelineEvent';

// Styles
import './styles.scss';

// Utils
function getItemStyles(offset) {
    if (!offset) {
        return {
            display: 'none'
        };
    }

    const { x, y } = offset;
    const transform = `translate(${x}px, ${y}px)`;
    return {
        transform,
        WebkitTransform: transform
    };
}

export const EventDragLayer = () => {
    const {
        itemType,
        isDragging,
        item,
        currentOffset,
        clientOffset
    } = useDragLayer(monitor => {
        return {
            item: monitor.getItem(),
            itemType: monitor.getItemType(),
            currentOffset: monitor.getSourceClientOffset(),
            clientOffset: monitor.getClientOffset(),
            isDragging: monitor.isDragging()
        };
    });

    if (!isDragging) {
        return null;
    }

    function renderItem() {
        const { id, groupId, width = 151 } = item;

        if (itemType === EVENT_TIMELINE_CELL) {
            return (
                <div style={getItemStyles(currentOffset)}>
                    <StyledEventsTimelineEvent
                        width={width}
                        harvestEventUuid={id}
                        isDragLayer
                        groupId={groupId}
                    />
                </div>
            );
        }
        if (itemType === EVENT_TABLE_ROW) {
            return (
                <div style={getItemStyles(clientOffset)}>
                    <StyledEventsTimelineEvent
                        width={width}
                        harvestEventUuid={id}
                        isDragLayer
                        groupId={groupId}
                    />
                </div>
            );
        }
        return undefined;
    }
    return <div className="event-drag-layer">{renderItem()}</div>;
};

export default EventDragLayer;
